export const MAX_CACHE_SIZE = 5
export const CACHE_TTL = 5 * 60 * 1000

export interface CacheEntry {
  data: string
  timestamp: number
}

export class LRUCacheWithTTL {
  private cache = new Map<string, CacheEntry>()
  private maxSize: number
  private ttl: number

  constructor(maxSize: number = MAX_CACHE_SIZE, ttl: number = CACHE_TTL) {
    this.maxSize = maxSize
    this.ttl = ttl
  }

  get(key: string): string | undefined {
    const entry = this.cache.get(key)
    if (!entry) return undefined

    if (Date.now() - entry.timestamp > this.ttl) {
      this.cache.delete(key)
      return undefined
    }

    this.cache.delete(key)
    this.cache.set(key, entry)
    return entry.data
  }

  set(key: string, value: string): void {
    if (this.cache.has(key)) {
      this.cache.delete(key)
    }

    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value
      if (firstKey) this.cache.delete(firstKey)
    }

    this.cache.set(key, {
      data: value,
      timestamp: Date.now(),
    })
  }

  has(key: string): boolean {
    return this.get(key) !== undefined
  }

  clear(): void {
    this.cache.clear()
  }
}
